import React, { FC } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './styles.module.css';

interface Props {
    className?: string;
    isOnAir: boolean;
    isStarted: boolean;
    onClick: () => void;
}

export const LiveOnAirControlComponent: FC<Props> = ({ className, isOnAir, isStarted, onClick }) =>
    isStarted ? (
        <button
            onClick={onClick}
            className={classnames(styles.root, className, {
                [styles.isOnAir]: isOnAir,
            })}
        >
            {isOnAir ? (
                <FormattedMessage
                    id="features.player.955ad3298db330b5ee880c2c9e6f23a0"
                    defaultMessage="Live"
                    description="Информация о том, что канал в прямом эфире в фиче плеера"
                />
            ) : (
                <FormattedMessage
                    id="features.player.eae32f89c997222c9859e0e8cd80379c"
                    defaultMessage="Back to the stream"
                    description="Информация о том, что канал не в прямом эфире в фиче плеера"
                />
            )}
        </button>
    ) : null;
